export default "__VITE_ASSET__Bd1pCUBU__"